module.exports = __webpack_public_path__ + "static/media/sugata_logo.d3f0dfb2.png";